import { Button } from "@/components/ui/button";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Link } from "react-router-dom";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";
import CanonicalTag from "@/components/CanonicalTag";
const HowTo = () => {
  const [openSections, setOpenSections] = useState<{
    [key: string]: boolean;
  }>({
    living: true,
    work: false,
    wellness: false,
    kids: false,
    hosting: false,
    business: false,
    retreats: false
  });
  const toggleSection = (section: string) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  const livingUses = [{
    label: "Rental Income Suite",
    url: "https://udaadu.com/adu-as-rental-property"
  }, {
    label: "Private Guest House",
    url: "https://udaadu.com/how-to-use-adu-as-guest-house"
  }, {
    label: "Multi-Gen Family Home",
    url: "https://udaadu.com/how-to-use-adu-multigenerational-home"
  }, {
    label: "Short-Term Rental Hub",
    url: "https://udaadu.com/how-to-use-adu-airbnb-rental"
  }, {
    label: "Nurse/Teacher Housing",
    url: "https://udaadu.com/how-to-use-adu-rental-for-nurse-or-teacher"
  }, {
    label: "Aging-in-Place Suite",
    url: "https://udaadu.com/how-to-use-adu-for-aging-in-place"
  }, {
    label: "Caregiver Quarters",
    url: "https://udaadu.com/how-to-use-adu-for-live-in-caregiver"
  }, {
    label: "Shared Living ADU",
    url: "/how-to-use-adu-for-couples-or-roommates"
  }, {
    label: "Luxury Stay for Guests",
    url: "https://udaadu.com/how-to-use-adu-guest-house-luxury"
  }, {
    label: "Couples or Roommate Space",
    url: "/how-to-use-adu-couples-roommates"
  }, {
    label: "Accessible Senior Unit",
    url: "https://udaadu.com/how-to-use-adu-as-accessible-retirement-suite"
  }];
  const workProductivity = [{
    label: "Work-from-Home Office",
    url: "https://udaadu.com/how-to-use-adu-as-home-office"
  }, {
    label: "Small Business Office",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-office-for-small-business"
  }, {
    label: "Digital Nomad Base",
    url: "https://udaadu.com/how-to-use-adu-digital-nomad-hq"
  }, {
    label: "Writer's Cabin",
    url: "https://udaadu.com/how-to-use-adu-writers-studio"
  }, {
    label: "Tech Maker Lab",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-tech-lab-or-maker-space"
  }, {
    label: "Content Creator Studio",
    url: "https://udaadu.com/how-to-use-adu-as-content-creator-studio"
  }, {
    label: "Co-Working Office Hub",
    url: "https://udaadu.com/how-to-use-adu-as-co-working-or-shared-office"
  }, {
    label: "Vacation Rental HQ",
    url: "https://udaadu.com/how-to-use-adu-as-hospitality-office"
  }, {
    label: "Tinker Shed",
    url: "https://udaadu.com/how-to-use-adu-as-hobby-lab-or-tinker-shed"
  }];
  const wellnessCreative = [{
    label: "Creative Arts Studio",
    url: "https://udaadu.com/how-to-use-adu-creative-studio"
  }, {
    label: "Backyard Gym & Wellness",
    url: "https://udaadu.com/how-to-use-adu-gym-wellness"
  }, {
    label: "Music Practice Studio",
    url: "https://udaadu.com/how-to-use-adu-music-studio"
  }, {
    label: "Personal Art Studio",
    url: "https://udaadu.com/how-to-use-adu-art-studio"
  }, {
    label: "Pro Artist Studio",
    url: "https://udaadu.com/how-to-use-adu-artist-studio"
  }, {
    label: "Therapy or Healing Room",
    url: "https://udaadu.com/how-to-use-adu-as-therapy-office-or-healing-space"
  }, {
    label: "Sound & Energy Room",
    url: "https://udaadu.com/how-to-use-adu-as-sound-healing-or-energy-therapy-space"
  }, {
    label: "Photography Studio",
    url: "https://udaadu.com/how-to-use-adu-as-photography-studio"
  }, {
    label: "Music Lesson Room",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-music-lesson-room"
  }];
  const kidsEducation = [{
    label: "Homeschooling ADU",
    url: "https://udaadu.com/how-to-use-adu-home-school"
  }, {
    label: "Teen Lounge Space",
    url: "https://udaadu.com/how-to-use-adu-as-teen-hangout-space"
  }, {
    label: "Tutoring & Classroom Space",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-classroom-or-tutoring-space"
  }, {
    label: "Alternative Schoolhouse",
    url: "https://udaadu.com/how-to-use-adu-home-school-classroom"
  }, {
    label: "Study Lounge or Reading Zone",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-library-study"
  }, {
    label: "Mini Daycare Center",
    url: "https://udaadu.com/how-to-use-adu-as-mini-daycare-or-learning-pod"
  }, {
    label: "Reading & Library Room",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-library-or-reading-room"
  }];
  const hostingEvents = [{
    label: "Game & Media Den",
    url: "https://udaadu.com/how-to-use-adu-as-game-room-or-media-room"
  }, {
    label: "Home Speakeasy Bar",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-bar-or-speakeasy"
  }, {
    label: "Private Home Theater",
    url: "https://udaadu.com/how-to-use-adu-home-theater"
  }, {
    label: "Multimedia Gaming Lounge",
    url: "https://udaadu.com/how-to-use-adu-game-room-media-room"
  }, {
    label: "Chef's Demo Kitchen",
    url: "https://udaadu.com/how-to-use-adu-as-guest-chef-demo-kitchen"
  }, {
    label: "Wedding/Event Retreat Suite",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-guest-retreat-for-events"
  }];
  const businessRevenue = [{
    label: "Backyard Barber Studio",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-barber-or-beauty-studio"
  }, {
    label: "Pet Grooming Station",
    url: "https://udaadu.com/how-to-use-adu-as-pet-grooming-studio"
  }, {
    label: "Home Retail Showroom",
    url: "https://udaadu.com/how-to-use-adu-as-boutique-retail-or-showroom"
  }, {
    label: "Vintage Fashion Studio",
    url: "https://udaadu.com/how-to-use-adu-as-backyard-vintage-showroom"
  }];
  const retreatsQuiet = [{
    label: "Zen Backyard Retreat",
    url: "https://udaadu.com/how-to-use-adu-backyard-retreat"
  }, {
    label: "Laundry or Mudroom Utility",
    url: "https://udaadu.com/how-to-use-adu-backyard-laundry-or-mudroom"
  }, {
    label: "Eco Retreat or Off-Grid Home",
    url: "https://udaadu.com/how-to-use-adu-for-eco-living-or-off-grid-retreat"
  }, {
    label: "Quiet Writer's Airbnb",
    url: "https://udaadu.com/how-to-use-adu-as-writers-retreat-bnb"
  }];
  const faqData = [{
    question: "What are the most profitable ways to use an ADU?",
    answer: "Popular options include long-term rentals, Airbnb units, or housing for traveling nurses. Explore rental-focused ADUs above for maximum income potential."
  }, {
    question: "Can I use my ADU to run a small business from home?",
    answer: "Yes—many homeowners turn their ADUs into offices, salons, therapy spaces, or content studios. See business-focused ADUs in our sections above."
  }, {
    question: "What's the difference between long-term and short-term ADU rentals?",
    answer: "Long-term rentals provide steady monthly income, while short-term rentals (like Airbnb) can yield higher returns but require more management."
  }, {
    question: "Can an ADU be used for both living and working?",
    answer: "Absolutely! Many ADUs serve dual purposes as live-work spaces, home offices with guest accommodations, or flexible multi-use areas."
  }, {
    question: "How do I choose the right ADU design for my needs?",
    answer: "Consider your primary goal (income, family space, work area), local zoning laws, and your lifestyle needs. Our use cases above can help guide your decision."
  }];
  const renderButtonGroup = (buttons: typeof livingUses) => <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      {buttons.map((button, index) => <Link key={index} to={button.url} className="block w-full bg-secondary hover:bg-brand text-secondary-foreground hover:text-white border-2 border-muted-foreground/20 hover:border-brand transition-all duration-200 rounded-md p-4 text-left no-underline" style={{
      pointerEvents: 'auto'
    }}>
          <span className="text-sm font-medium leading-tight">
            {button.label}
          </span>
        </Link>)}
    </div>;
  return <>
      <CanonicalTag url="https://www.udaadu.com/how-to" />
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <div className="container mx-auto px-4 py-8">
          <div className="text-center mb-12">
            <h1 className="font-bold text-brand mb-4 text-5xl">
              50 Ways to Use Your ADU
            </h1>
            <p className="text-xl text-muted-foreground max-w-4xl mx-auto mb-6">
              Explore over 50 unique ADU use cases—whether you're renting, hosting, working remotely, or building a creative studio. Transform your Accessory Dwelling Unit into a profitable and functional space that meets your specific needs.
            </p>
          </div>

          <div className="max-w-6xl mx-auto space-y-6">
            {/* Living Uses */}
            <Collapsible open={openSections.living} onOpenChange={() => toggleSection('living')}>
              <CollapsibleTrigger className="flex items-center justify-between w-full p-4 bg-brand text-black rounded-lg hover:bg-brand/90 transition-colors">
                <h2 className="text-2xl font-semibold text-black">Living Uses</h2>
                {openSections.living ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
              </CollapsibleTrigger>
              <CollapsibleContent className="mt-4">
                <p className="text-muted-foreground mb-4">Rentals, guest accommodations, and multigenerational housing solutions.</p>
                {renderButtonGroup(livingUses)}
              </CollapsibleContent>
            </Collapsible>

            {/* Work & Productivity */}
            <Collapsible open={openSections.work} onOpenChange={() => toggleSection('work')}>
              <CollapsibleTrigger className="flex items-center justify-between w-full p-4 bg-brand text-black rounded-lg hover:bg-brand/90 transition-colors">
                <h2 className="text-2xl font-semibold text-black">Work & Productivity</h2>
                {openSections.work ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
              </CollapsibleTrigger>
              <CollapsibleContent className="mt-4">
                <p className="text-muted-foreground mb-4">Home offices, creative studios, and professional workspaces.</p>
                {renderButtonGroup(workProductivity)}
              </CollapsibleContent>
            </Collapsible>

            {/* Wellness & Creative */}
            <Collapsible open={openSections.wellness} onOpenChange={() => toggleSection('wellness')}>
              <CollapsibleTrigger className="flex items-center justify-between w-full p-4 bg-brand text-black rounded-lg hover:bg-brand/90 transition-colors">
                <h2 className="text-2xl font-semibold text-black">Wellness & Creative</h2>
                {openSections.wellness ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
              </CollapsibleTrigger>
              <CollapsibleContent className="mt-4">
                <p className="text-muted-foreground mb-4">Art studios, music rooms, wellness spaces, and therapeutic environments.</p>
                {renderButtonGroup(wellnessCreative)}
              </CollapsibleContent>
            </Collapsible>

            {/* Kids & Education */}
            <Collapsible open={openSections.kids} onOpenChange={() => toggleSection('kids')}>
              <CollapsibleTrigger className="flex items-center justify-between w-full p-4 bg-brand text-black rounded-lg hover:bg-brand/90 transition-colors">
                <h2 className="text-2xl font-semibold text-black">Kids & Education</h2>
                {openSections.kids ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
              </CollapsibleTrigger>
              <CollapsibleContent className="mt-4">
                <p className="text-muted-foreground mb-4">Homeschooling spaces, tutoring centers, and youth-focused areas.</p>
                {renderButtonGroup(kidsEducation)}
              </CollapsibleContent>
            </Collapsible>

            {/* Hosting & Events */}
            <Collapsible open={openSections.hosting} onOpenChange={() => toggleSection('hosting')}>
              <CollapsibleTrigger className="flex items-center justify-between w-full p-4 bg-brand text-black rounded-lg hover:bg-brand/90 transition-colors">
                <h2 className="text-2xl font-semibold text-black">Hosting & Events</h2>
                {openSections.hosting ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
              </CollapsibleTrigger>
              <CollapsibleContent className="mt-4">
                <p className="text-muted-foreground mb-4">Entertainment spaces, bars, theaters, and event venues.</p>
                {renderButtonGroup(hostingEvents)}
              </CollapsibleContent>
            </Collapsible>

            {/* Business & Revenue */}
            <Collapsible open={openSections.business} onOpenChange={() => toggleSection('business')}>
              <CollapsibleTrigger className="flex items-center justify-between w-full p-4 bg-brand text-black rounded-lg hover:bg-brand/90 transition-colors">
                <h2 className="text-2xl font-semibold text-black">Business & Revenue</h2>
                {openSections.business ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
              </CollapsibleTrigger>
              <CollapsibleContent className="mt-4">
                <p className="text-muted-foreground mb-4">Revenue-generating businesses and service-based operations.</p>
                {renderButtonGroup(businessRevenue)}
              </CollapsibleContent>
            </Collapsible>

            {/* Retreats & Quiet Zones */}
            <Collapsible open={openSections.retreats} onOpenChange={() => toggleSection('retreats')}>
              <CollapsibleTrigger className="flex items-center justify-between w-full p-4 bg-brand text-black rounded-lg hover:bg-brand/90 transition-colors">
                <h2 className="text-2xl font-semibold text-black">Retreats & Quiet Zones</h2>
                {openSections.retreats ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
              </CollapsibleTrigger>
              <CollapsibleContent className="mt-4">
                <p className="text-muted-foreground mb-4">Peaceful retreats, utility spaces, and off-grid living.</p>
                {renderButtonGroup(retreatsQuiet)}
              </CollapsibleContent>
            </Collapsible>
          </div>

          {/* FAQ Section */}
          <section className="mt-16 max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-foreground mb-8 text-center">Frequently Asked Questions</h2>
            <div className="space-y-6">
              {faqData.map((faq, index) => <div key={index} className="bg-muted/50 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-foreground mb-3">{faq.question}</h3>
                  <p className="text-brand">{faq.answer}</p>
                </div>)}
            </div>
          </section>

          <div className="mt-12 text-center">
            <p className="text-muted-foreground mb-4">
              Ready to start your ADU journey?
            </p>
            <Button asChild className="bg-brand hover:bg-brand/90">
              <Link to="/">
                Get Started Today
              </Link>
            </Button>
          </div>
        </div>

        {/* JSON-LD Schema for FAQ */}
        <script type="application/ld+json">
          {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqData.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
        </script>
      </div>
      <Footer />
    </>;
};
export default HowTo;